export const stringToHslColor = (str, s = 65, l = 55) => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash) % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      mode: "index",
      intersect: false,
      backgroundColor: "rgba(33, 33, 33, 0.9)",
      borderWidth: 0,
      padding: 10,
      cornerRadius: 8,
    },
  },
  layout: {
    padding: { left: 10, right: 20, top: 10, bottom: 10 },
  },
  scales: {
    x: {
      title: { display: true, text: "Practice" },
      ticks: {
        maxRotation: 45,
        minRotation: 20,
        autoSkip: false,
      },
      grid: { display: false },
    },
    y: {
      title: { display: true, text: "Dictation Count" },
      beginAtZero: true,
      grid: { color: "rgba(0,0,0,0.05)" },
    },
  },
};
